import {
  CHECK_LOGIN,
  LOGIN_USER_SUCCESSFUL,
  API_ERROR,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  LOAD_USER_SUCCESSFUL,
} from './actionTypes';

const initialState = {
  loginError: '',
  message: null,
  loading: true,
  isAuthenticated: false,
  user: null,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_LOGIN:
      state = {
        ...state,
        loading: true,
      };
      break;

    case LOGIN_USER_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload.admin_details,
        isAuthenticated: true,
      };
      break;

    case LOAD_USER_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        isAuthenticated: true,
      };
      break;

    case LOGOUT_USER:
      state = { ...initialState };
      break;

    case LOGOUT_USER_SUCCESS:
      state = { ...initialState };
      break;

    case API_ERROR:
      state = {
        ...state,
        loading: false,
        loginError: action.payload,
        isAuthenticated: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
